<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('常见问题.问题分类')" prop="problemTypeId" >
        <a-select :placeholder="$t('通用.输入.请选择')+$t('常见问题.问题分类')" v-model="form.problemTypeId" allowClear>
          <a-select-option v-for="(item, index) in helpTypeList" :value="item.id"
                           :key="index">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('常见问题.常见问题标题')" prop="title" >
        <a-input v-model="form.title" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('常见问题.常见问题标题')" />
      </a-form-model-item>

      <!--多语言集成-->
      <a-form-item v-if="form.localeList.length > 0" :label="this.$t('通用.文本.多语言配置')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" class="margin-bottom-10">
        <a-table :data-source="form.localeList" :columns="localeColumns" rowKey="id" :pagination="false" bordered>
          <span slot="locale" slot-scope="text, record">
           <custom-dict-tag :options="customDict.LocaleEnum" :value="record.locale"/>
          </span>
          <div slot="name" slot-scope="text, record" >
            <a-input v-model="record.name" :maxLength="16" :placeholder="$t('通用.输入.请输入')+$t('主营行业.分类名称')"  @blur.native.capture="validatorLocaleName"  />
          </div>
          <div slot="action" slot-scope="text, record">
            <a-button type="primary" @click="getTranslation(record)">
              {{$t('通用.按钮.翻译')}}
            </a-button>
          </div>
        </a-table>
        <span style="color: red;">{{ errorMessage }}</span>
      </a-form-item>
      <!--多语言集成-->


      <a-form-model-item :label="$t('常见问题.显示顺序')" prop="orderSort" >
        <a-input-number style="width: 100%" v-model="form.orderSort" :maxLength="32" @change="limitSort" :placeholder="$t('通用.输入.请输入')+$t('常见问题.显示顺序')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('常见问题.状态')" prop="status" >
        <a-radio-group v-model="form.status"  button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.StatusEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('常见问题.常见问题简述')" prop="sketch" >
        <a-input v-model="form.sketch" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('常见问题.常见问题简述')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('常见问题.常见问题内容')" prop="contentInfo" >
        <editor v-model="form.contentInfo" :placeholder="$t('通用.输入.请输入')"/>
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getProblem, addProblem, updateProblem, pageProblem} from '@/api/help/problem'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import {listType} from "@/api/help/type";
import Editor from "@/components/Editor/Editor";
//多语言集成
import {translation} from "@/api/tool/common";
//多语言集成

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    Editor,

  },
  data () {
    return {
      helpTypeList:[],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        problemTypeId: null,

        title: null,

        sketch: null,

        contentInfo: null,

        orderSort: null,

        status: 0,

        remark: null,

        createTime: null,
        // 多语言集成
        localeList: [],
        // 多语言集成
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        problemTypeId: [
          { required: true, message: this.$t('常见问题.问题分类')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        title: [
          { required: true, message: this.$t('常见问题.常见问题标题')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        sketch: [
          { required: true, message: this.$t('常见问题.常见问题简述')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        contentInfo: [
          { required: true, message: this.$t('常见问题.常见问题内容')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      },
      //多语言集成
      errorMessage:undefined,
      localeColumns: [
        {
          title: this.$t('通用.文本.语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: { customRender: 'locale' }
        }, {
          title: this.$t('主营行业.分类名称'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          key: 'name'
        }, {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'action',
          key: 'action',
          slots: { title: 'addbtn', customRender: 'brandName' },
          scopedSlots: { customRender: 'action' }
        }
      ],
      //多语言集成
    }
  },
  filters: {
  },
  created () {
    this.getHelpTypeList();
  },
  //多语言集成
  computed: {
    ...mapGetters(['customDict'])
  },
//多语言集成
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    getHelpTypeList () {
      listType().then(response => {
        this.helpTypeList = response.data
      })
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        problemTypeId: null,
        title: null,
        sketch: null,
        contentInfo: null,
        orderSort: null,
        status: 0,
        remark: null,
        createTime: null,
        //多语言集成
        localeList:[]
        //多语言集成
      }

    },
    limitSort(sort) {
      let val = sort;
      if(val==null||val==undefined||val==''|| val<0){
        val=0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.orderSort = val
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加');
      //多语言集成
      this.initLocale();
      //多语言集成
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getProblem({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateProblem(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addProblem(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    //多语言集成
    initLocale() {
      //获取全局配置的语言
      const sysLangList = globalThis.$openLangList;
      //初始化多语言
      let localeList = [];
      let i = 1;
      this.customDict.LocaleEnum.forEach(e => {
        if(sysLangList.includes(e.type)){
        localeList.push({"id": i, "locale": e.type, 'name': ''})
        i++;
      }
    })
      this.form.localeList = localeList;
    },

    validatorLocaleName() {
      let errorMessage = "";
      var localeList = this.form.localeList;
      let localeEnum = this.customDict.LocaleEnum;
      localeList.forEach(e=>{
        if (!e.name) {
        let localeName = localeEnum.find(locale=>locale.type===e.locale).name;
        errorMessage += localeName + this.$t('通用.文本.不能为空')+';';
      }
    })
      if (errorMessage) {
        this.errorMessage = errorMessage;
        return false;
      }
      this.errorMessage = "";
      return true;
    },
    getTranslation(record) {
      if (!this.form.title) {
        return
      }
      let data = {"text": this.form.title, "locale": record.locale};
      translation(data).then(response => {
        record.name = response.data
    });

    },
    limitSort(record) {
      // console.log(i);
      let val=record.sort.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1');
      if(val==null||val==undefined||val==''){
        val=0
      }
      if (val > 21474836) {
        val = 21474836
      }
      record.sort = val
    },
    //多语言集成
  }
}
</script>
